module.exports = __webpack_public_path__ + "static/media/DriftDiver.07253b20.jpg";